<template>
  <v-app>
    <v-form lazy-validation @submit.prevent="submit">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>fact_check</md-icon>
          </div>
          <h4 class="title">新增项目</h4>
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-size-100 mx-auto">
              <v-select v-model="form.course" :items="courseList" item-text="name" item-value="_id" label="课程 *" :rules="[v => !!v || '课程不能为空']"></v-select>
              <v-text-field v-model="form.name" label="项目名称 *" :rules="[v => !!v || '项目名称不能为空']" hint="请输入实训项目名称"></v-text-field>
              <v-textarea v-model="form.description" label="项目简介" rows="1" auto-grow hint="请描述实训项目简介,控制在1000字内"></v-textarea>
              <v-text-field v-model="form.manager" label="负责人 *" :rules="[v => !!v || '负责人不能为空']" hint="请负责人先注册为系统用户，并输入负责人的系统用户名"></v-text-field>
              <md-field>
                <label>相关资料</label><md-file v-model="$data.files" multiple />
                <span class="md-helper-text"> 可上传多个文件</span>
              </md-field>
            </div>
          </div>
        </md-card-content>
        <md-card-actions md-alignment="right">
          <md-button class="md-success" type="submit">确 定</md-button>&nbsp;&nbsp;&nbsp;
          <md-button class="md-success" @click="toProject">返 回</md-button>
        </md-card-actions>
      </md-card>
    </v-form>
  </v-app>
</template>

<script>
import { listCourse } from '@/api/course'
import { addProject, updateProject } from '@/api/project'
import Swal from 'sweetalert2'

import { SlideYDownTransition } from 'vue2-transitions'
import { extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'

extend('required', required)

export default {
  components: {
    SlideYDownTransition
  },
  data() {
    return {
      form: {
        required: '',
        name: '',
        university: '',
        college: '',
        refer: ['高职', '高技'],
        major: '高压电气专业',
        manager: '林力明',
        files: ''
      },
      courseList: []
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    /** 初始化 */
    async init() {
      const courseResult = await listCourse({ getAll: true })
      if (courseResult.code == 200) {
        this.courseList = courseResult.data.rows
      }
      this.form = this.$route.query
    },
    /** 表单提交 */
    async submit() {
      const result = !this.form._id ? await addProject(this.form) : await updateProject(this.form)
      if (result.code == 200) {
        this.$notify({
          timeout: 1500,
          message: '操作成功！',
          icon: 'add_alert',
          horizontalAlign: 'center',
          verticalAlign: 'bottom',
          type: 'success'
        })
        this.$router.push({ path: './project' })
      }
    },
    toProject() {
      this.$router.push({ path: './project' })
    }
  }
}
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
